import { Component, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { IconComponent } from '../../components/icon/icon.component';
import { OverlayComponent } from '../../components/overlay/overlay.component';
import { TooltipButtonComponent } from '../../components/button/tooltip-button.component';
import { HrefDirective } from '../../directives/href/href.directive';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-rate-of-return-tooltip',
  templateUrl: 'rate-of-return-tooltip.component.html',
  styleUrls: ['rate-of-return-tooltip.component.scss'],
  imports: [
    TranslateDirective,
    TooltipButtonComponent,
    IconComponent,
    OverlayComponent,
    HrefDirective,
    TranslatePipe
  ]
})
export class RateOfReturnTooltipComponent {
  readonly position = input<string>('center-bottom');
  readonly ariaDescribedBy = input<string | undefined>(undefined, { alias: 'aria-describedby' });
  readonly changeLink = input<boolean>(undefined);
}
